import {
  listIntegrations,
  getIntegration,
  subscribe,
  unsubscribe,
} from 'api/emailMarketing'
import { oauthTokenSelector } from 'selectors/app'

export const doFetchEmailMarketingIntegrations = () => (dispatch, getState) => {
  dispatch({
    type: 'EMAIL_MARKETING_FETCH_INTEGRATIONS_REQUEST',
  })
  const state = getState()
  const token = oauthTokenSelector(state)
  return listIntegrations(token)
    .then(item => {
      return dispatch({
        type: 'EMAIL_MARKETING_FETCH_INTEGRATIONS_SUCCESS',
        item,
      })
    })
    .catch(item => {
      return dispatch({
        type: 'EMAIL_MARKETING_FETCH_INTEGRATIONS_FAILURE',
        item,
      })
    })
}

export const doFetchEmailMarketingIntegrationState = (id, userId) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'EMAIL_MARKETING_GET_INTEGRATION_STATE_REQUEST',
    item: { id: `legacy_${id}` },
  })
  const state = getState()
  const token = oauthTokenSelector(state)
  return getIntegration(token, id, userId)
    .then(data => {
      return dispatch({
        type: 'EMAIL_MARKETING_GET_INTEGRATION_STATE_SUCCESS',
        item: { id: `legacy_${id}`, data },
      })
    })
    .catch(data => {
      return dispatch({
        type: 'EMAIL_MARKETING_GET_INTEGRATION_STATE_FAILURE',
        item: { id: `legacy_${id}`, data },
      })
    })
}

export const doSubscribeToEmailList = (id, userId, list) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'EMAIL_MARKETING_SUBSCRIBE_REQUEST',
    item: { id: `legacy_${id}` },
  })
  const state = getState()
  const token = oauthTokenSelector(state)
  return subscribe(token, id, userId, list)
    .then(data =>
      dispatch({
        type: 'EMAIL_MARKETING_SUBSCRIBE_SUCCESS',
        item: { id: `legacy_${id}`, data },
      })
    )
    .then(() => dispatch(doFetchEmailMarketingIntegrationState(id, userId)))
    .catch(data =>
      dispatch({
        type: 'EMAIL_MARKETING_SUBSCRIBE_FAILURE',
        item: { id: `legacy_${id}`, data },
      })
    )
}

export const doUnsubscribeFromEmailList = (id, userId, list) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'EMAIL_MARKETING_UNSUBSCRIBE_REQUEST',
    item: { id: `legacy_${id}` },
  })
  const state = getState()
  const token = oauthTokenSelector(state)
  return unsubscribe(token, id, userId, list)
    .then(data => {
      return dispatch({
        type: 'EMAIL_MARKETING_UNSUBSCRIBE_SUCCESS',
        item: { id: `legacy_${id}`, data },
      })
    })
    .then(() => dispatch(doFetchEmailMarketingIntegrationState(id, userId)))
    .catch(data => {
      return dispatch({
        type: 'EMAIL_MARKETING_UNSUBSCRIBE_FAILURE',
        item: { id: `legacy_${id}`, data },
      })
    })
}
